import * as React from "react";
import type { SVGProps } from "react";

const FacilityTram = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M6.66406 1.66391H13.3335"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0019 18.3378L13.2695 15.7393"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.72848 15.7393L4.99609 18.3378"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99887 4.1651V1.66406"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5009 15.8366H7.49878C5.65718 15.8366 4.16406 14.3434 4.16406 12.5018V6.66608C4.16406 5.28467 5.2837 4.16504 6.6651 4.16504H13.3345C14.716 4.16504 15.8356 5.28467 15.8356 6.66608V12.5018C15.8356 14.3434 14.3425 15.8366 12.5009 15.8366Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6668 18.3377H8.33203"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8356 10.0008H4.16406"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0206 12.5017C12.8481 12.5017 12.708 12.6417 12.7097 12.8143C12.7097 12.9869 12.8497 13.1269 13.0223 13.1269C13.1949 13.1269 13.3349 12.9869 13.3349 12.8143C13.3349 12.6417 13.1949 12.5017 13.0206 12.5017"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.97768 12.5017C6.80511 12.5017 6.66505 12.6417 6.66672 12.8143C6.66672 12.9869 6.80678 13.1269 6.97934 13.1269C7.15192 13.1269 7.29198 12.9869 7.29198 12.8143C7.29198 12.6417 7.15192 12.5017 6.97768 12.5017"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityTram.displayName = "FacilityTram";

export default FacilityTram;
